<article *ngIf="example"
         class="result-detail-layout1">

  <!-- 도움말 -->
  <app-example-help-btn></app-example-help-btn>

  <div class="detail-head-box">
    <div class="item-option-box">

      <div class="option-box">
        <app-example-play-btn [example]="example"></app-example-play-btn>
      </div>

      <div class="option-box">
        <article class="bookmark-btn-box">
          <button type="button"
                  class="bookmark-btn {{ bookmarkCss }}"
                  (click)="onToggleBookmark($event)"></button>
        </article>
      </div>

    </div>
  </div>

  <div class="detail-body-box">
    <app-example-disp *ngIf="exampleSJ"
                      [exampleSJ]="exampleSJ"></app-example-disp>
  </div>

  <div class="detail-word-box" *ngIf="example.word1">
    <div class="section-title">단어</div>

    <div class="word-card"
         (click)="onClickWordCard($event, example.word1, 1)">
      <!-- #container 의 위치는 컴포넌트의 가장 상위 첫번째 child이어야 함 -->
      <ng-container #wordCardContainer1></ng-container>
      <div class="word-card-content">
        <div class="word-card-head">
          <app-word-disp [word]="example.word1" [wrapHanja]="true"></app-word-disp>
          <app-word-play-btn [word]="example.word1"></app-word-play-btn>
        </div>
        </div>
      <div class="arrow-icon"></div>
    </div>

    <div class="word-card" *ngIf="example.word2"
         (click)="onClickWordCard($event, example.word2!, 2)">
      <ng-container #wordCardContainer2></ng-container>
      <div class="word-card-content">
        <div class="word-card-head">
          <app-word-disp [word]="example.word2" [wrapHanja]="true"></app-word-disp>
          <app-word-play-btn [word]="example.word2"></app-word-play-btn>
        </div>
        </div>
      <div class="arrow-icon"></div>
    </div>
  </div>

</article>
